import { Radio } from "@mantine/core";
import { RadioSurvey } from "../../../components";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <RadioSurvey
      label={t("supervisor.label")}
      {...form.getInputProps("IL_008_jefe")}
    >
      <Radio label={t("gender.man")} value="Hombre" />
      <Radio label={t("gender.woman")} value="Mujer" />
    </RadioSurvey>
  );
};

export default Component;
